import { render, staticRenderFns } from "./AbkRemovedUsersList.vue?vue&type=template&id=a6537a3e&scoped=true&"
import script from "./AbkRemovedUsersList.vue?vue&type=script&lang=js&"
export * from "./AbkRemovedUsersList.vue?vue&type=script&lang=js&"
import style0 from "./AbkRemovedUsersList.vue?vue&type=style&index=0&id=a6537a3e&lang=scss&scoped=true&"
import style1 from "./AbkRemovedUsersList.vue?vue&type=style&index=1&id=a6537a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6537a3e",
  null
  
)

export default component.exports